export default "__VITE_ASSET__BKfDuLie__"